import type { OrderListDesignTokens } from '@primeuix/themes/types/orderlist';

export default {
    root: {
        gap: '1.125rem',
    },
    controls: {
        gap: '0.5rem',
    },
} satisfies OrderListDesignTokens;
